<script setup>
import { cn } from '@/lib/utils';

const props = defineProps({
  type: String,
  class: String,
});
</script>

<template>
  <div :class="cn('h-full w-full', props.class)">
    <img
      v-if="type === 'seede'"
      src="/images/platform/seede.svg"
      alt="Seede Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'deepseek'"
      src="/images/platform/deepseek.svg"
      alt="DeepSeek Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'moonshot'"
      src="/images/platform/moonshot.svg"
      alt="Moonshot Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'claude'"
      src="/images/platform/claude.svg"
      alt="Claude Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'minimax'"
      src="/images/platform/minimax.svg"
      alt="Minimax Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'gemini'"
      src="/images/platform/gemini.svg"
      alt="Gemini Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'openai'"
      src="/images/platform/openai.svg"
      alt="closeAI Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'xai'"
      src="/images/platform/xai.svg"
      alt="xAI Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'qwen'"
      src="/images/platform/qwen.svg"
      alt="Qwen Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'doubao'"
      src="/images/platform/doubao.svg"
      alt="Doubao Logo"
      class="h-full w-full"
    />
    <img
      v-if="type === 'zai'"
      src="/images/platform/zai.svg"
      alt="zAI Logo"
      class="h-full w-full"
    />
  </div>
</template>
